export default "__VITE_ASSET__De_EeRNG__"